/**
 * BY DEMURE – Header JS
 * Drop into: assets/bydemure-header.js
 */

(function () {
  'use strict';

  const header = document.querySelector('[data-header]');
  if (!header) return;

  // ============================================
  // STICKY / SCROLL BEHAVIOUR
  // ============================================
  const isSticky = header.classList.contains('bd-header--sticky');
  const isTransparent = header.classList.contains('bd-header--transparent');

  let lastScrollY = 0;
  let ticking = false;

  function onScroll() {
    lastScrollY = window.scrollY;
    if (!ticking) {
      window.requestAnimationFrame(updateHeader);
      ticking = true;
    }
  }

  function updateHeader() {
    const threshold = 40;

    if (lastScrollY > threshold) {
      header.classList.add('is-scrolled');
    } else {
      header.classList.remove('is-scrolled');
    }

    ticking = false;
  }

  if (isSticky || isTransparent) {
    window.addEventListener('scroll', onScroll, { passive: true });
    updateHeader();
  }

  // ============================================
  // ANNOUNCEMENT BAR DISMISS
  // ============================================
  const announcementClose = document.querySelector('.bd-announcement__close');
  const announcement = document.querySelector('.bd-announcement');

  if (announcementClose && announcement) {
    announcementClose.addEventListener('click', function () {
      announcement.style.maxHeight = announcement.offsetHeight + 'px';
      announcement.style.overflow = 'hidden';
      announcement.style.transition = 'max-height 0.3s ease, opacity 0.3s ease';

      requestAnimationFrame(() => {
        announcement.style.maxHeight = '0';
        announcement.style.opacity = '0';
      });

      setTimeout(() => {
        announcement.classList.add('is-hidden');
      }, 320);

      try {
        sessionStorage.setItem('bd-ann-dismissed', '1');
      } catch (e) {}
    });

    // Restore dismiss state
    try {
      if (sessionStorage.getItem('bd-ann-dismissed') === '1') {
        announcement.classList.add('is-hidden');
      }
    } catch (e) {}
  }

  // ============================================
  // SEARCH TOGGLE
  // ============================================
  const searchToggle = document.querySelector('[data-search-toggle]');
  const searchPanel = document.querySelector('[data-search]');
  const searchClose = document.querySelector('[data-search-close]');
  const searchInput = searchPanel ? searchPanel.querySelector('.bd-search__input') : null;

  function openSearch() {
    if (!searchPanel) return;
    searchPanel.classList.add('is-open');
    searchPanel.setAttribute('aria-hidden', 'false');
    if (searchInput) {
      setTimeout(() => searchInput.focus(), 100);
    }
  }

  function closeSearch() {
    if (!searchPanel) return;
    searchPanel.classList.remove('is-open');
    searchPanel.setAttribute('aria-hidden', 'true');
  }

  if (searchToggle) {
    searchToggle.addEventListener('click', function () {
      const isOpen = searchPanel.classList.contains('is-open');
      isOpen ? closeSearch() : openSearch();
    });
  }

  if (searchClose) {
    searchClose.addEventListener('click', closeSearch);
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeSearch();
      closeMobileMenu();
    }
  });

  // ============================================
  // MOBILE MENU
  // ============================================
  const mobileMenu = document.querySelector('[data-mobile-menu]');
  const menuToggles = document.querySelectorAll('[data-menu-toggle]');
  const menuCloses = document.querySelectorAll('[data-menu-close]');
  const burger = document.querySelector('.bd-burger');

  function openMobileMenu() {
    if (!mobileMenu) return;
    mobileMenu.classList.add('is-open');
    mobileMenu.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    if (burger) {
      burger.classList.add('is-active');
      burger.setAttribute('aria-expanded', 'true');
    }
  }

  function closeMobileMenu() {
    if (!mobileMenu) return;
    mobileMenu.classList.remove('is-open');
    mobileMenu.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (burger) {
      burger.classList.remove('is-active');
      burger.setAttribute('aria-expanded', 'false');
    }
  }

  menuToggles.forEach(function (btn) {
    btn.addEventListener('click', function () {
      const isOpen = mobileMenu && mobileMenu.classList.contains('is-open');
      isOpen ? closeMobileMenu() : openMobileMenu();
    });
  });

  menuCloses.forEach(function (btn) {
    btn.addEventListener('click', closeMobileMenu);
  });

  // ============================================
  // MOBILE SUBMENU ACCORDION
  // ============================================
  const expandBtns = document.querySelectorAll('.bd-mobile-nav__expand');

  expandBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      const item = btn.closest('.bd-mobile-nav__item');
      const sub = item ? item.querySelector('.bd-mobile-nav__sub') : null;

      if (!sub) return;

      const isOpen = sub.classList.contains('is-open');

      // Close all
      document.querySelectorAll('.bd-mobile-nav__sub.is-open').forEach(function (el) {
        el.classList.remove('is-open');
      });
      document.querySelectorAll('.bd-mobile-nav__expand.is-active').forEach(function (el) {
        el.classList.remove('is-active');
      });

      if (!isOpen) {
        sub.classList.add('is-open');
        btn.classList.add('is-active');
      }
    });
  });

  // ============================================
  // TRANSPARENT HEADER — add body class
  // ============================================
  if (isTransparent) {
    document.body.classList.add('bd-has-transparent-header');
  }

  // ============================================
  // CART COUNT UPDATE (Shopify AJAX)
  // ============================================
  document.addEventListener('cart:updated', function (e) {
    const countEl = document.querySelector('[data-cart-count]');
    if (!countEl) return;
    const count = e.detail && e.detail.itemCount;
    if (count !== undefined) {
      countEl.textContent = count;
      countEl.style.display = count > 0 ? 'flex' : 'none';
    }
  });

})();